<template>
  <v-container
    class="my-6"
  >
    <v-row
      justify="center"
    >
      <v-col
        cols="12"
        sm="8"
      >
        <v-card>
          <v-card-title primary-title>
            <v-row
              class="text-center"
            >
              <v-col cols="12">
                <v-icon x-large class="blue--text text--darken-2">
                  mdi-account-minus
                </v-icon>
              </v-col>
              <v-col cols="12" class="headline text-center">
                Account löschen?
              </v-col>
            </v-row>
          </v-card-title>

          <v-card-text>
            <v-row
              justify="center"
            >
              <v-col
                cols="12"
                sm="10"
              >
                <p class="body-1">
                  Wenn Du auf "Account löschen" gehst, wird Dein Account aus der laufenden Saison gelöscht und am Ende der Saison archiviert. Deine Mannschaft steht als erster Absteiger fest und wird nach der Saison aus dem Spiel genommen. Die Verträge Deiner Spieler werden aufgelöst.<br> Deine E-Mail-Adresse wird nach der aktuellen Saison gelöscht, so dass Du Dich in der kommenden Saison neu Registrieren kannst.
                </p>
              </v-col>
              <v-col
                cols="12"
                sm="10"
              >
                <v-text-field
                  prepend-icon="mdi-security"
                  hint="Passwort eingeben"
                  v-model="mPassword"
                  name="password"
                  label="Passwort eingeben"
                  required
                  :type="showPW ? 'password' : 'text'"
                  @click:append="() => (showPW = !showPW)"
                  :append-icon="showPW ? 'mdi-eye' : 'mdi-eye-off'"
                />

                <my-alert
                  v-if="this.$store.state.error"
                  type="error"
                  :error="this.$store.state.error"
                  :title="this.$store.state.errorTitle"
                />
              </v-col>
            </v-row>
          </v-card-text>

          <v-card-actions>
            <v-btn
              outlined
              large
              class="warning--text mx-auto"
              @click="cancelAccount()"
              :loading="this.$store.state.loading"
            >
              Abbrechen <v-icon right class="warning--text">
                mdi-cancel
              </v-icon>
            </v-btn>
            <v-btn
              outlined
              large
              class="primary--text mx-auto"
              @click.native.stop="deleteAccount()"
              :loading="this.$store.state.loading"
            >
              Account löschen <v-icon right class="blue--text text--darken-2">
                mdi-send
              </v-icon>
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { ROOT_LOADING, ROOT_SET_SNACKBAR } from '../../store/mutation-types'

export default {
  name: 'Deleteaccount',
  metaInfo: {
    title: 'Account löschen'
  },
  data () {
    return {
      mPassword: '',
      showPW: true
    }
  },
  methods: {

    cancelAccount: function () {
      this.mPassword = ''
      this.$router.replace({ path: '/settings' })
    },
    deleteAccount: async function () {
      if (this.mPassword.length == null || this.mPassword.length < 1) {
        this.$store.commit(ROOT_SET_SNACKBAR, 'Bitte Passwort eingeben!')
        return false
      }

      this.$store.commit(ROOT_LOADING, true)

      const deleteAccount = await this.$store.dispatch('managerStore/deleteAccount', {
        password: this.mPassword
      })
      if (deleteAccount) {
        // do logout and return to startpage
        this.$router.replace({ path: '/logout' })
      }
    }
  },
  created () {
    // check if user is already logged in and then redirect to home
    if (this.$store.state.matchEvaluationInProgress) {
      this.$router.replace({ path: '/' })
    }
  }
}
</script>
